import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageCircle, MapPin } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 px-6 bg-slate-900" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-4">
            Let's Talk
          </h2>
          <p className="text-xl text-slate-300 mb-12" data-id="element-5">
            Whether you're looking to buy quality calls or sell your traffic,
            we're here to help you grow.
          </p>

          <div className="space-y-6" data-id="element-6">
            <motion.a href="mailto:sanchit@sanchitcopy.com" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="flex items-center justify-center gap-4 bg-slate-800 hover:bg-slate-700 rounded-xl p-6 transition-colors duration-200" data-id="element-7">
              <Mail className="w-6 h-6 text-emerald-500" data-id="element-8" />
              <div className="text-left" data-id="element-9">
                <div className="text-sm text-slate-400 font-medium" data-id="element-10">Email</div>
                <div className="text-lg text-white font-semibold" data-id="element-11">
                  sanchit@sanchitcopy.com
                </div>
              </div>
            </motion.a>

            <motion.a href="https://t.me/Netroid01" target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="flex items-center justify-center gap-4 bg-slate-800 hover:bg-slate-700 rounded-xl p-6 transition-colors duration-200" data-id="element-12">
              <MessageCircle className="w-6 h-6 text-emerald-500" data-id="element-13" />
              <div className="text-left" data-id="element-14">
                <div className="text-sm text-slate-400 font-medium" data-id="element-15">
                  Telegram
                </div>
                <div className="text-lg text-white font-semibold" data-id="element-16">
                  @Netroid01
                </div>
              </div>
            </motion.a>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex items-center justify-center gap-4 bg-slate-800 rounded-xl p-6" data-id="element-17">
              <MapPin className="w-6 h-6 text-emerald-500" data-id="element-18" />
              <div className="text-left" data-id="element-19">
                <div className="text-sm text-slate-400 font-medium" data-id="element-20">
                  Location
                </div>
                <div className="text-lg text-white font-semibold" data-id="element-21">
                  Toronto, Canada
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}